export const lawFirmData = {
  company: {
    name: "Bufete Legal Especializado",
    slogan: "Excelencia y compromiso en servicios legales",
    description: "Más de 20 años de experiencia brindando servicios legales de alta calidad",
    contact: {
      phone: "+34 900 123 456",
      email: "contacto@bufetelegal.com",
      address: "Calle Principal 123, Madrid"
    }
  },
  services: [
    {
      id: 1,
      title: "Derecho Corporativo",
      description: "Asesoramiento legal integral para empresas",
      icon: "business",
      details: ["Constitución de empresas", "Contratos mercantiles", "Fusiones y adquisiciones"]
    },
    {
      id: 2,
      title: "Derecho Laboral",
      description: "Especialistas en relaciones laborales",
      icon: "work",
      details: ["Contratos laborales", "Despidos", "Negociaciones sindicales"]
    },
    // ... más servicios
  ],
  team: [
    {
      id: 1,
      name: "Ana Perez",
      position: "Socia Principal ?",
      image: "/images/team/ana.jpg",
      specialties: ["Derecho Mercantil", "Derecho Internacional"]
    },
    // ... más miembros del equipo
  ],
  testimonials: [
    {
      id: 1,
      name: "Carlos Rodríguez",
      company: "Empresa S.A.",
      text: "Excelente servicio y atención profesional...",
      rating: 5
    },
    // ... más testimonios
  ]
};